import { defaults } from 'lodash';
import { IMAGES_DEFAULT_HEIGHT, IMAGES_DEFAULT_WIDTH } from '../../iframe/additional-apps.utils';
import { FrameItem } from '../../../../models/session';
import { FLAGS } from '../../../../services/flags.service';
import { BoardItemConfig, CreationContext } from './board-item-configurations';

export class ImageConfigurations extends BoardItemConfig {
  url?: string;
  // Durable URL of the original uploaded file (PDF/office doc) this image was
  // derived from, when the image is a PDF page rendered as a standalone Image
  // item. Persisted as resource_state.source_url so the board stays traceable
  // back to its source (url already holds the converted page-image URL).
  sourceUrl?: string;
  // Indicating that the stacking order have been manipulated after the item was migrated from HTML to fabric
  migratedFromHtmlToFabric: boolean;

  static defaultBoardItemConfigurations: Partial<BoardItemConfig> = {
    width: IMAGES_DEFAULT_WIDTH,
    height: IMAGES_DEFAULT_HEIGHT,
  };

  constructor(
    configurations: Partial<ImageConfigurations> & Partial<BoardItemConfig>,
    globalCreationParams: CreationContext,
  ) {
    super(
      {
        ...ImageConfigurations.defaultBoardItemConfigurations,
        ...configurations,
      },
      globalCreationParams,
    );

    const imageConfigurations = defaults(configurations, {});

    this.url = imageConfigurations.url;
    this.sourceUrl = imageConfigurations.sourceUrl;
    this.migratedFromHtmlToFabric =
      !!imageConfigurations.migratedFromHtmlToFabric ||
      (globalCreationParams.isNewlyCreatedItem &&
        globalCreationParams.featureFlagsService.isFlagEnabled(FLAGS.RENDER_IMAGES_IN_FABRIC));
  }

  static fromYCanvasItemObject(
    frameItem: FrameItem,
    globalCreationsParams: CreationContext,
  ): ImageConfigurations {
    const configurations = BoardItemConfig.fromYCanvasItemObject(
      frameItem,
      globalCreationsParams,
      ImageConfigurations.defaultBoardItemConfigurations,
    );

    return new ImageConfigurations(
      {
        ...configurations,
        url: frameItem.resource_state?.resource_url,
        sourceUrl: frameItem.resource_state?.source_url,
        migratedFromHtmlToFabric: frameItem.migratedFromHtmlToFabric,
      },
      globalCreationsParams,
    );
  }
}
